var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"canvasElement"}),_c('video',{directives:[{name:"show",rawName:"v-show",value:(!_vm.useDewarp),expression:"!useDewarp"}],ref:"videoElement",staticClass:"video-player-size",attrs:{"autoplay":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }